//  For each product on the page
document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    /************
     Product Swipers
     ************/
    section.querySelectorAll('.productVisualWrap').forEach(item => {
        let productSwiper = new Swiper(item.querySelector(".productVisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: item.querySelector(".productVisualSwiperNext"),
                prevEl: item.querySelector(".productVisualSwiperPrev"),
            },
            on: {
                slideChange: function () {
                    if (!item.querySelector(".productVisualSwiperSlide")) {
                        return;
                    }
                    // update the thumbnail active class
                    item.querySelector(".productVisualThumbsSlide.active").classList.remove("active");
                    item.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");

                }
            }
        });

        // change slide on thumbnail click
        item.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
            element.addEventListener("click", function () {
                // change slide
                productSwiper.slideTo(this.dataset.index - 1);
            });
        });

    })


    // update active variant on input changes
    section.querySelectorAll(".product input").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/
    async function updateProduct() {

        let color = section.querySelector('.productOptionItemValuesLabelInput.color:checked').value;
        if (color === "Carbon Black") {
            color = "black";
        } else {
            color = "white";
        }

        // update materials section image
        document.querySelectorAll('.materialV2BodyDiagramImg').forEach(image => {
            if (image.classList.contains(color)) {
                image.classList.add("active")
            } else {
                image.classList.remove("active")
            }
        })

        // update image section
        document.querySelectorAll('.imageSectionV2Image').forEach(image => {
            if (image.classList.contains(color)) {
                image.classList.add("active")
            } else {
                image.classList.remove("active")
            }
        })


        /**************
         Active Swiper
         ***************/
        section.querySelectorAll('.productVisualWrap').forEach(item => {
            if (item.classList.contains(color)) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        })

        // color label
        section.querySelector('.productOptionItemControlsTitleColor').textContent = section.querySelector('.productOptionItemValuesLabelInput.color:checked').value;

    }

    // on load, update the product
    // this accomplishes loading the correct variant image on page load
    updateProduct();


});